import { analisarPreco, resolverPreco } from "../calculator/engine";

const centavos = valor => Math.round((valor + Number.EPSILON) * 100);

// O carrinho guarda preço por unidade em centavos. A prévia e a gravação
// usam o mesmo rateio, inclusive quando as quantidades exigem arredondamento.
export function planejarPrecoOrcamento(itens, { modo = "margem", valorAlvo, taxas = [] }) {
  if (!itens?.length) throw new Error("Adicione um produto ao orçamento.");
  if (!["margem", "preco"].includes(modo)) throw new Error("Escolha margem ou preço manual.");
  const alvo = Number(valorAlvo);
  if (valorAlvo == null || String(valorAlvo).trim() === "" || !Number.isFinite(alvo) || alvo < 0) {
    throw new Error(modo === "preco" ? "Informe um preço total válido." : "Informe uma margem válida.");
  }
  const linhas = itens.map(item => {
    const quantidade = Number(item.quantidade ?? 1);
    const preco = Number(item.preco ?? 0), custo = Number(item.custo_total ?? 0);
    if (!Number.isSafeInteger(quantidade) || quantidade < 1 || !Number.isFinite(preco) || preco < 0 || !Number.isFinite(custo) || custo < 0) throw new Error("Revise os preços e as quantidades dos produtos.");
    return { quantidade, preco, custo };
  });
  const custoTotal = linhas.reduce((s, l) => s + l.custo * l.quantidade, 0);
  const totalAtual = linhas.reduce((s, l) => s + l.preco * l.quantidade, 0);
  const quantidadeTotal = linhas.reduce((s, l) => s + l.quantidade, 0);
  const desejado = resolverPreco({ custoTotal, taxas, modo, valorAlvo:alvo });
  if (desejado.inviavel) throw new Error("Revise a margem e as taxas de venda.");
  const totalAlvo = centavos(desejado.precoFinal);
  if (![totalAlvo, centavos(custoTotal), centavos(totalAtual), quantidadeTotal].every(Number.isSafeInteger)) throw new Error("O valor informado é muito alto.");
  const precosCentavos = linhas.map(l => {
    const proporcao = totalAtual > 0 ? l.preco / totalAtual : custoTotal > 0 ? l.custo / custoTotal : 1 / quantidadeTotal;
    return Math.round(totalAlvo * proporcao);
  });
  let restante = totalAlvo - linhas.reduce((s, l, i) => s + precosCentavos[i] * l.quantidade, 0);
  // Absorve os centavos restantes quando as quantidades permitem, sem
  // criar preços com frações de centavo ou alterar a quantidade dos itens.
  [...linhas.keys()].sort((a, b) => linhas[a].quantidade - linhas[b].quantidade).forEach(i => {
    const delta = Math.round(restante / linhas[i].quantidade);
    const novoRestante = restante - delta * linhas[i].quantidade;
    if (precosCentavos[i] + delta >= 0 && Math.abs(novoRestante) < Math.abs(restante)) {
      precosCentavos[i] += delta;
      restante = novoRestante;
    }
  });
  const totalAplicado = totalAlvo - restante;
  if (!Number.isSafeInteger(totalAplicado) || !precosCentavos.every(Number.isSafeInteger)) throw new Error("O valor informado é muito alto.");
  return {
    precos:precosCentavos.map(v => v / 100),
    totalSolicitado:totalAlvo / 100,
    diferencaCentavos:totalAplicado - totalAlvo,
    resultado:analisarPreco({ precoFinal:totalAplicado / 100, custoTotal, taxas }),
  };
}
